/**
 * A form multi-line text input.
 */

import {TailwindContents} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import React, {type TextareaHTMLAttributes} from 'react';

export const TextArea = ({
  className,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  return (
    <TailwindContents>
      <textarea
        className={clsx(
          'night-aware',
          'h-full w-full flex-1',
          'p-8 leading-6',
          'focus:outline-none',
          'dark:bg-moon-900 dark:selection:bg-moon-650',
          'dark:text-moon-200  dark:selection:text-moon-200',
          'relative bottom-0 top-0 items-center rounded-sm',
          'outline outline-1 outline-moon-250 dark:outline-moon-700 dark:focus-within:outline-teal-600',
          props.disabled
            ? 'opacity-50'
            : 'hover:outline hover:outline-2 hover:outline-teal-500/40 focus:outline-2',
          'outline outline-1 outline-moon-250 hover:outline-teal-500/40 focus:outline-teal-500/40',
          'appearance-none border-none',
          'placeholder-moon-500',
          className
        )}
        {...props}
      />
    </TailwindContents>
  );
};
